import { Box, Text } from '@modusign/design-system';
import { ReactNode } from 'react';

interface ContractLinkParticipantSettingInfoProps {
  children: ReactNode;
  name: string;
  width?: string;
}

function ContractLinkParticipantSettingInfo({
  children,
  name,
  width,
}: ContractLinkParticipantSettingInfoProps) {
  return (
    <Box p={1} role="row" width={width}>
      <Text
        as="p"
        color="textNeutralLight"
        fontSize="sm"
        mb={4}
        role="columnheader"
        textAlign="left"
      >
        {name}
      </Text>
      <Text as="p" m={0} p={0} role="cell" textAlign="left">
        {children}
      </Text>
    </Box>
  );
}

export default ContractLinkParticipantSettingInfo;
